import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: ${(p) => p.theme.colors.oceanBlue};
`
const StyledText = styled.text`
  fill: ${(p) => p.theme.colors.oceanBlue};
  font-size: 22px;
`

const ClockIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="-6 -6 55.432 51.649">
    <g transform="translate(-2.011 -3.69)">
      <StyledPath d="M28.615 3.69a1.124 1.124 0 1 0 0 2.248 20.58 20.58 0 1 1-20.344 23.53l1.621 1.621a1.124 1.124 0 1 0 1.589-1.589l-3.774-3.775a1.128 1.128 0 0 0-1.592 0L2.34 29.5a1.124 1.124 0 1 0 1.589 1.589l2.01-2.01A22.824 22.824 0 1 0 28.615 3.69z" />
      <StyledPath
        d="M25.8 27.564h10.68a1.124 1.124 0 1 0 0-2.248h-9.552V13.692a1.124 1.124 0 0 0-2.248 0V26.44a1.123 1.123 0 0 0 1.12 1.124z"
        transform="translate(2.811 1.101)"
      />
      <StyledText transform="translate(21 18)">30</StyledText>
    </g>
  </SvgIcon>
)

export default ClockIcon
